import React from 'react';
import {observer} from 'mobx-react';
import {AnalyticsTab, Store} from '../../stores/store';
import {I18n, MessageProvider, TProvider} from '../../i18n/i18n';
import {DateUtils} from '../../utility/DateUtils';
import {blueButtonClassName} from '../../styles/style';
import {ProductDiagramInstruction, SearchDiagramInstruction} from '../../stores/OdtExportStore';

@observer
export default class AddReportInstructionToQueueButton extends React.Component<{store: Store}> {
    private generateDiagramInstructions(targetAnalyticsTab: AnalyticsTab): SearchDiagramInstruction[] | ProductDiagramInstruction[] {
        const {requestedNormalDiagrams, requestedChannelDiagrams} = this.props.store.lineDiagramStore;
        if (targetAnalyticsTab !== this.props.store.activeAnalyticsTab || targetAnalyticsTab === AnalyticsTab.Dashboard) {
            return [];
        }

        const channelDiagramInstructions = requestedChannelDiagrams.map((channelDiagrams) => ({
            ...channelDiagrams,
            channel: channelDiagrams.channelName,
        }));

        const normalDiagramInstructions = requestedNormalDiagrams.map((normalDiagrams) => ({
            kpi: normalDiagrams.kpi,
            channel: normalDiagrams.channelName,
            [targetAnalyticsTab === AnalyticsTab.SearchView ? 'searchterm' : 'productId']: normalDiagrams.searchtermOrProductId,
        }));

        return [...channelDiagramInstructions, ...normalDiagramInstructions];
    }

    private addReportPageToQueue = (t: MessageProvider): void => {
        const {
            mainDateRange: {startDate, endDate},
            mainDateRange,
        } = this.props.store.timeIntervalStore;
        const {reportModalFooter, reportModalHeader, reportTargetCurrency, reportBuildInstructions} = this.props.store.odtExportStore;
        reportBuildInstructions.push({
            interval: DateUtils.copyDateRange(mainDateRange),
            targetCurrency: reportTargetCurrency,
            heading: t('table:report', {dateRange: DateUtils.formatDateRange(startDate, endDate)}),
            header: reportModalHeader,
            footer: reportModalFooter,
            searchDiagrams: this.generateDiagramInstructions(AnalyticsTab.SearchView),
            productDiagrams: this.generateDiagramInstructions(AnalyticsTab.ProductView),
        });
        this.props.store.odtExportStore.reportModalIsOpen = false;
    };

    public render(): React.ReactNode {
        return (
            <div style={{float: 'right'}}>
                <TProvider>
                    {(t) => (
                        <button className={blueButtonClassName} style={{marginRight: 5}} onClick={() => this.addReportPageToQueue(t)}>
                            <I18n i18nKey="table:addToReportButtonTitle" />
                        </button>
                    )}
                </TProvider>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Table/AddReportInstructionToQueueButton.tsx